/** @format */

import React from "react";
import So from "./cards/So";
import Manbalar from "./cards/Manbalar";
import Balanslar from "./cards/Balanslar";

function Abmk({ date }) {
  return (
    <div className='dashboard'>
      <div className='mgk-box abmk'>
        <Balanslar date={date} a={1} s={0} z={0} />
        <So date={date} />
        <Manbalar date={date} singlerow={1} region='abmk' />
      </div>
    </div>
  );
}

export default Abmk;
